import Button from "../../components/button"
import Modal from "../../components/modal"
import UploadFiled from "../../components/fileduploader"
import { postAPI, uploadApi } from "../../api/api"
import { useState } from "react";
import Headline5 from "../../components/headings/Headline5";
import DropDownListselect from "../../components/dropdown";
import NotificationAlert from "../../components/notification";
import { REACT_APP_CANDIDATEFILTER, REACT_APP_CANDIDATE_FRELLANCER } from "../../utils/common";
const PublicDatabaseModal = (props: any) => {

  const [document, setDocument] = useState<string>('')
  const { v4: uuidv4 } = require("uuid");

  const [source, setSource] = useState<any>('');
  const [message, setMessage] = useState<any>('');
  const [errormessage, setErrormessage] = useState<any>('');
  const [sourceError, setSourceError] = useState<any>('');
  const [notification, setNotification] = useState<boolean>(false)


  const uploadFile = (e: any) => {

    setMessage('');
    setErrormessage('');
    let file = e.target.files[0]
    let type = file.type

    let fileName = uuidv4() + e.target.files[0].name.replace(/ /g, "");

    let value = {
      "action": "putObject",
      "filename": 'uploadedCandidateData/' + fileName
    }

    postAPI(REACT_APP_CANDIDATE_FRELLANCER + '/resume-signed-url', value).then((data) => {

      if (data) {
        setMessage('This might take a while, We are trying to extract most of the information to make your life easier.')
        setErrormessage('This might take a while, We are trying to extract most of the information to make your life easier.');
      }
      let signedUrl = data.url;
      uploadApi(signedUrl, file, type).then((response: any) => {
        // props.clickHandler(fileName)
        setDocument(fileName)
        setMessage('');
        setErrormessage('');
      })
    })


  };
  const userloginId = localStorage.getItem("loginId");

  const onChangetype = (e: any) => {
    setSourceError('');
    setSource(e.target.value.name);
  };
  const handlesubmit = () => {
    if (source === '') {
      setSourceError('Please select the source');
      return;
    }


    if (document === '') {
      setMessage('Please upload the sheet');
      setErrormessage('Please upload the sheet');
      return;
    }

    let value =
    {
      "fileName": document,
      "allocated_to": userloginId,
      "source": source,
    }
    postAPI(REACT_APP_CANDIDATEFILTER + '/addCandidateFromPublicData', value).then((response) => {
      if (response.status === 'Success') {
        setMessage('public database uploaded successfully')
        setErrormessage('');
        setNotification(true)
        setTimeout(() => {
          setNotification(false)
          props.onClose();
        }, 3000)

      }
      else {
        setMessage('please try again later')
        setErrormessage('please try again later');
      }
    });
  }
  const onClose = () => {
    setNotification(false)
  }
  return (

    <Modal size={'small'} title={'Upload'} onClose={() => props.onClose()}>
      <Headline5>Upload</Headline5>
      {notification && <NotificationAlert onClose={onClose} closable={true} >
        {message}
      </NotificationAlert>}
      <div className="form-group">
        <label className="lablel">Source</label>
        <DropDownListselect
          name="source"
          onChange={onChangetype}
          data={[
            { "id": 1, "name": "Seekout" }]}
          textField="name"
          dataItemKey="id"


        />
        <p style={{ color: "red", textAlign: "center" }}> {sourceError ? sourceError : ''}</p>
      </div>
      <div className="modal-file-uploader">
        <UploadFiled uploadFile={uploadFile} />
        <p style={{ color: "red", textAlign: "center" }}> {errormessage ? errormessage : ''}</p>
      </div>
      <div style={{
        marginTop: "3%", display: "flex",
        justifyContent: "end"
      }}>
        <Button onClick={handlesubmit} type="submit" variant="primary">Save</Button>
      </div>
    </Modal >
  )
}
export default PublicDatabaseModal

